import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'

export const databasesAdapter = createEntityAdapter()

const databasesSlice = createSlice({
  name: 'databases',
  initialState: databasesAdapter.getInitialState(),
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('databases')) {
        databasesAdapter.upsertMany(state, payload.databases)
      }
    })
  },
})

// Selectors

export const databasesSelectors = databasesAdapter.getSelectors(state => state.data.databases)

export default databasesSlice.reducer
